import type { KnowledgeEdge, KnowledgeEntity } from '@/entities/knowledge';
import { KnowledgeEntityDetails } from '@/entities/knowledge';

export function KnowledgeDetailsPanel({
  entity,
  edges,
}: {
  entity: KnowledgeEntity | null;
  edges: KnowledgeEdge[];
}) {
  return (
    <KnowledgeEntityDetails
      entity={entity}
      edges={edges}
      className="h-full overflow-y-auto"
    />
  );
}
